import { useContext } from "react";

import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import get from "@beeldit/core/services/get";
import { StatisticsActionContext } from "./StatisticsActionContext";

function useGet() {
  const { setElement, setShowModal } = useContext(StatisticsActionContext);
  const errorHandler = useErrorHandler();

  return (
    id: any,
    onSuccess: any = (data: any) => {
      return data;
    }
  ) => {
    get(`players`, id, "?appends=statistics")
      .then((response: any) => {
        let data = response.data;
        data = onSuccess(response.data);
        setElement(data);
        setShowModal(true);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useGet;
